module.exports = __webpack_public_path__ + "img/republic-of-macedonia.e3658f78.svg";